/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchEducation
 */
export interface SourcingSearchEducation {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchEducation
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchEducation
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchEducation
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchEducation
     */
    graduationYear?: number;
}

/**
 * Check if a given object implements the SourcingSearchEducation interface.
 */
export function instanceOfSourcingSearchEducation(value: object): value is SourcingSearchEducation {
    return true;
}

export function SourcingSearchEducationFromJSON(json: any): SourcingSearchEducation {
    return SourcingSearchEducationFromJSONTyped(json, false);
}

export function SourcingSearchEducationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchEducation {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'content': json['content'] == null ? undefined : json['content'],
        'title': json['title'] == null ? undefined : json['title'],
        'graduationYear': json['graduationYear'] == null ? undefined : json['graduationYear'],
    };
}

export function SourcingSearchEducationToJSON(value?: SourcingSearchEducation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'content': value['content'],
        'title': value['title'],
        'graduationYear': value['graduationYear'],
    };
}

